import { Box, Slider, Stack, Typography } from "@mui/material";

export default function ControlSlider({
  title,
  subtitle,
  value,
  min,
  max,
  step,
  onChange,
  valueFormatter = (current) => current,
}) {
  return (
    <Box
      sx={{
        p: 2.25,
        borderRadius: 3,
        backgroundColor: (theme) => theme.palette.surface?.elevated,
        border: (theme) => `1px solid ${theme.palette.outline?.main}`,
      }}
    >
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Box>
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
        <Typography
          variant="subtitle2"
          sx={{
            minWidth: 56,
            px: 1.25,
            py: 0.5,
            borderRadius: 2,
            textAlign: "center",
            backgroundColor: (theme) => theme.palette.tonal?.soft,
            color: "text.primary",
          }}
        >
          {valueFormatter(value)}
        </Typography>
      </Stack>

      <Slider
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        sx={{ mt: 2.5 }}
      />
    </Box>
  );
}
